export const auditEndpoints = {
  list: '/audit-logs',
} as const

export const AUDIT_LIST_KEY = ['auditList'] as const

// Backend `AuditAction` (features/audit/enums/audit_action_enum.py) → TR etiket + Tag rengi.
export const AUDIT_ACTION_META: Record<
  string,
  { label: string; color: string }
> = {
  'question.review': { label: 'Soru İncelemesi', color: 'blue' },
  'batch.status': { label: 'Grup Statüsü', color: 'geekblue' },
  'batch.deliver': { label: "Bilgilig'e Teslim", color: 'purple' },
  'user.create': { label: 'Kullanıcı Oluştur', color: 'green' },
  'user.update': { label: 'Kullanıcı Güncelle', color: 'gold' },
  'user.password_change': { label: 'Parola Değişimi', color: 'volcano' },
  'role.create': { label: 'Rol Oluştur', color: 'green' },
  'role.update': { label: 'Rol Güncelle', color: 'gold' },
  'role.delete': { label: 'Rol Sil', color: 'red' },
}

// Eylem filtresi (Select) seçenekleri.
export const AUDIT_ACTION_OPTIONS = Object.entries(AUDIT_ACTION_META).map(
  ([value, meta]) => ({ value, label: meta.label })
)

// Backend `AuditTargetType` → TR etiket.
export const AUDIT_TARGET_LABELS: Record<string, string> = {
  question: 'Soru',
  batch: 'Grup',
  user: 'Kullanıcı',
  role: 'Rol',
}
